import 'datatables.net-dt/css/jquery.dataTables.css'
import 'datatables.net-buttons-dt/css/buttons.dataTables.css'
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import 'chosen-js/chosen.css';
import chosen from 'chosen-js/chosen.jquery';
import 'datatables.net-rowgroup-dt/css/rowGroup.dataTables.min.css'

import React, {Component} from 'react';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import moment from 'moment';
import Help from '../../../generics/help';

const $ = require('jquery');
$.DataTable = require('datatables.net-dt');

require('datatables.net-buttons/js/dataTables.buttons.min' );

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const jzip = require( 'jszip');
require( 'datatables.net-buttons/js/buttons.html5.min' );
window.JSZip = jzip;

require( 'datatables.net-rowgroup-dt/js/rowGroup.dataTables.min');

var session = sessionStorage.getItem('health_facilities_name');
var Config = require('../../../../config');

class Pending extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.searching = this.searching.bind(this);
		this.isValidForm = this.isValidForm.bind(this);
		this.showCtrlError = this.showCtrlError.bind(this);
		this.setTable = this.setTable.bind(this);
		this.dateCompate = this.dateCompare.bind(this);

		this.state = {
			lab_sections_id:["all"],
			lab_sections:[],

			start_date 	: "",
			end_date 	: "",

			status:"all",
			table_list:[],
			listado:[],

			convoke_places:[],
			convoke_places_id:"all",

			//test datatable to export
			columns:[
				{title:'Fecha Unidad', width:'15%'},
				{title:'No. Unidad', width:'15%'},
				{title:'Fecha-Hora Validación', width:'20%'},
				{title:'Detalle', width:'50%'},
			],
			filename:"Pendientes de validación",

			date_hour:"",
			medical:"",
		}
	}

	componentWillMount(){
		var medical = JSON.parse(sessionStorage.getItem('medical_staff'));

		this.setState({
			health_facilities_id: sessionStorage.getItem('health_facilities_id'),
			medical:(medical.lastname1 !== null ? medical.lastname1 : "")+' '+
					(medical.lastname2 !== null ? medical.lastname2 : "")+' '+medical.names
		});

		if(!this.props.hiddeToReport){
			this.props.reload();
		}

	}

	componentDidMount(){
		this.props.waiting.handleShow('Cargando...');
		setTimeout(()=>{
			this.props.waiting.handleClose();
		}, 300)
		
		this.$select = $(this.select);
		this.$select.chosen();
		this.$select.on('change', this.handleChange);

		fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			var aux = response.split('|');
			var hours = this.getHourFormat(aux[1]);

			this.setState({
				date_hour:aux[0]+' '+hours,
			});
		})

		var health = this.state.health_facilities_id;
 		
 		if(sessionStorage.getItem('matriz') === '1' && health === sessionStorage.getItem('health_facilities_id')){
 			health = 'all';
 		}

 		fetch(Config.default.apiGateway.URL+'convoke_places/by_hf?health_facilities_id='+health, {
			method: 'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					convoke_places: response
				});
			}
		});

		this.getLabSection();

		this.setTable();
	}

	getHourFormat(hr){
		var format = hr.split(' ');
		var hrs    = format[0].split(':');
		var ampm = format.length === 2 ? format[1] : format[1]+' '+format[2];
		var hour = parseInt(hrs[0],10);
		var minute = parseInt(hrs[1],10);
		
		if((ampm === "PM" || ampm === "p. m.") && hour < 12)	hour += 12;

		if((ampm === "AM" || ampm === "a. m.") && hour === 12)	hour -= 12;

		if(hour < 10) hour = '0'+hour;

		if(minute < 10) minute = '0'+minute;
		var nvaHour = hour+':'+minute;

		return nvaHour;
	}

	setTable(){
		this.$select.trigger("chosen:updated");
		
		var fechas = "Información Del: "+moment(this.state.start_date).format("DD/MM/YYYY")+ 
					" Al: "+moment(this.state.end_date).format("DD/MM/YYYY")
		this.$el = $(this.el);
		var table = this.$el.DataTable({
			dom: 'Bfrtip',
			buttons: [
				{
                	extend: 'excelHtml5',
                	title: this.state.filename
            	},
            	{
                	extend: 'pdf',
                	title: this.state.filename,
                	orientation:'landscape',
                	customize: (doc)=> { 
                		doc.content.unshift({
							image: this.props.header_document,
							alignment:'center',
							width:this.props.w_head
						});
						
						doc.content.splice(2, 0, {text: fechas, margin:[10,0,0,10] });
						

						doc.content.splice(3, 0, {
							columns:[
								this.state.lab_section_name !== "" ?
									{text: 'Seccion Laboratorio', width:'12%', fontSize:8}
								: {text:"", width:0},
								this.state.lab_section_name !== "all" ?
									{text: this.state.lab_section_name, bold:1, margin:[0,0,0,10], fontSize:8}
								: {text:"", width:0},

							]
						});

                		doc.content[4].table.widths=["10%","10%","25%","55%"];
                		doc.defaultStyle.fontSize = 8; 
                		doc.footer = {text: this.state.date_hour+'\t-\t'+this.state.medical, alignment: 'right',margin: [ 0, 0, 50, 0 ]};
                	} 
            	}
            ],
			data: this.state.listado,
			columns:this.state.columns,
			oLanguage:{
				"sProcessing":"Procesando...",
				"sZeroRecords":"No se encontraron resultados",
				"sEmptyTable":"Ningún dato disponible en esta tabla",
				"sInfoPostFix":"",
				"sSearch":"Buscar:",
				"sUrl":"",
				"sInfoThousands":",",
				"sLoadingRecords":"Cargando...",
				"fnInfoCallback":null,
			},
			paging:false,
			responsive:true,
			searching: false,
			scrollY:"32em",
			scrollX: true,
			autoWidth: false,
			ordering:true,
			info:false,
			
			createdRow: function(row, data, dataIndex){
				
			}
		});
		if (table.rows().indexes().length === 0 ) {
			table.buttons('.buttons-html5').disable();
		}else {
			table.buttons('.buttons-html5').enable();
		}
	}

	handleChange(e){
		if(e.target.name === 'lab_sections_id'){
			var options = e.target.options;
			var value = [];
			var name = "";
			for (var i = 0, l = options.length; i < l; i++) {
			    if (options[i].selected) {
			    	if(options[i].value === 'all'){
			    		value = [];
			    		value.push(options[i].value);
			    		break;
			    		
			    	}else{
			    		value.push(parseInt(options[i].value));
			    		name += options[i].text + ', '
			    	}
			      
			    }
			}

			this.setState({
				[e.target.name]: value,
				lab_section_name:name.substring(0,name.length-2)
			});

			this.$select.val(value).trigger("chosen:updated");
		}else{
			this.setState({
				[e.target.name]: e.target.value
			});
		}

			

		if(document.getElementById(e.target.name).className.includes('error')){
			document.getElementById(e.target.name).classList.remove('error');
		}

		
	}

	searching(){
		if(this.isValidForm()){
			if(this.dateCompate()){
				this.props.waiting.handleShow('Buscando...');

				var sections = [];
				if(this.state.lab_sections_id[0] === 'all'){
					this.state.lab_sections.map((l)=>{
						return sections.push(l.id);
					});
				}else{
					sections = this.state.lab_sections_id;
				}
					

				var obj = {
					health_facilities_id:this.state.health_facilities_id,
					start_date: this.state.start_date,
					end_date: this.state.end_date,
					status:this.state.status,
					lab_section_ids: sections,
					convoke_places_id: this.state.convoke_places_id,
				}
				
				fetch(Config.default.apiGateway.URL+'reports/pending_validation',{
					method: 'POST',
					body:JSON.stringify(obj),
					headers: new Headers({
						'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
						'Accept'		: 'application/json',
						'Content-Type'	: 'application/json'
					})
				}).then(res => {
					
					if(res.ok){
						return res.json();
					}else{
						this.props.waiting.handleClose();
						res.text().then((msg)=>{
							swal('Error', msg, 'error');
						});
					}
				}).then(response => {
					if(response !== undefined){
						this.setState({
							listado: [],
						});

						var list = [];

						response.map((res)=>{
							list.push([
								moment(res.timestamp_date).format('DD/MM/YYYY'),
								res.donation_number,
								moment(res.validation_date).format('DD/MM/YYYY HH:mm',),
								res.detail
							]);
						});


						this.setState({listado:list});

						setTimeout(()=>{
							this.props.waiting.handleShow('Cargando...');
							this.$el = $(this.el);
							this.$el.DataTable().destroy();
							this.$el.empty();
						}, 500);

						setTimeout(()=>{
							this.props.waiting.handleClose();
							this.setTable();
						}, 1000);
					
							
						this.props.waiting.handleClose();
					}
				});
			}else{
				swal('Error', 'La Fecha Hasta debe ser mayor o igual a Fecha Desde', 'error');
			}
			
		}else{
			swal('Error', 'Campos Incompletos', 'error');
		}
	}

	dateCompare(){
		var ini = moment(this.state.start_date);
		var fin = moment(this.state.end_date);
		var date_ok = true;
		if(this.state.search_type === 'date'){
			if(ini !== 'Invalid date' && fin !== 'Invalid date'){
				if(fin < ini){
					date_ok = false;
					document.getElementById('end_date').classList.add('error');
				}else{
					document.getElementById('end_date').classList.remove('error');
				}
			}else{
				date_ok = false;
			}		
		}
		

		return date_ok;
	}

	isValidForm() {
		const select = document.querySelector('form');
		const inputs = select.querySelectorAll('input, select');
	    let isFormValid = true;
	    
	    inputs.forEach(input => {
	    	if(input.required){
	    		
		      	const isInputValid = this.showCtrlError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		    	
		   
		  	}
	    });	    

	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		if (this.state[refName] === "") {

			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}
		

		return res;
	}

 	getLabSection(){
 		fetch(Config.default.apiGateway.URL+'lab_sections/by_health_facility?id='+this.state.health_facilities_id, {
			method: 'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){

				this.setState({
					lab_sections: response
				});

				this.$select.trigger("chosen:updated");
			}
		});
 	}

	render(){
		const {t} = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page">
					{session} ->
					{t('sidebar.nav.reports.MAIN')} ->
					Laboratorio ->
					Pendientes de Validación
					</h5>
				</div>
				
				<Help 
					{...this.props}
		            menu={"help_patients"} 
		            submenu={"help_pending_validation_report"}  />
				<div className="form-group" style={{paddingLeft:"0.5em"}}>

					<div className="col-xs-12">
						<form noValidate>
							<div className="col-xs-12 col-sm-2" style={{borderRight:"1px solid #e0e0e0"}}>
								<div className="form-group">
									<span className="span-min">Fecha Desde</span>
									<input type="date" className="form-control hour-input" name="start_date" id="start_date"
										value={this.state.start_date} onChange={this.handleChange} required  />
								</div>

								<div className="form-group">
									<span className="span-min">Fecha Hasta</span>
									<input type="date" className="form-control hour-input" name="end_date" id="end_date"
										value={this.state.end_date} onChange={this.handleChange} required />
								</div>
								
								<div className="form-group">
									<span className="span-min">Lugar de Colecta</span>
									<select className="form-control" name="convoke_places_id" id="convoke_places_id"
										value={this.state.convoke_places_id} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										{this.state.convoke_places.map((c, i)=>{
											return <option key={i} value={c.id}>
												{c.name}
											</option>
										})}
									</select>
								</div>

								<div className="form-group">
									<span className="span-min col-xs-12" style={{width:'100%'}}>Sección Laboratorio</span>
									<select className="form-control"  name="lab_sections_id" id="lab_sections_id"
										value={this.state.lab_sections_id} 
										multiple={true} required data-placeholder={'Seleccione...'}
										ref={el => this.select = el}>
										<option value="all">TODOS</option>
										{this.state.lab_sections.map((l, i)=>{
											return <option key={i} value={l.id}>
												{l.name}
											</option>
										})}
									</select>
									
								</div>

								<div className="form-group">
									<span className="span-min">Tipo</span>
									<select className="form-control"  name="status" id="status"
										value={this.state.status} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="all">Todos</option>
										<option value="accepted">Aceptado</option>
										<option value="pending">Pendiente</option>
										<option value="reject">Rechazado</option>
									</select>
								</div>
								<div style={{textAlign:"right"}}>
									<button type="button" className="btn btn-info" onClick={this.searching} style={{fontSize:"1em"}}>
										Buscar
									</button>
								</div>
							</div>

							<div className="col-xs-12 col-sm-10">
								<div className="col-xs-12">
									<div className="col-xs-12" style={{marginTop:"20px",textAlign: "center",fontWeight: "bold",textDecoration: "underline",fontSize:'16px'}}>
										<span>
											{this.state.filename}
										</span>
									</div>
								</div>
								
								<div className="col-xs-12" >
									<span>
										Información Del:   {this.state.start_date !== "" ? 
											moment(this.state.start_date).format('DD/MM/YYYY')
										:'  '}
									</span>
									<span style={{marginLeft:"5px"}}>	
										Al: {this.state.end_date !== "" ? 
											moment(this.state.end_date).format('DD/MM/YYYY')
										:'  '}
									</span>
								</div>

								<div className="col-xs-12">

									{this.state.lab_sections_id[0] !== 'all' && this.state.lab_sections_id[0] !== "" && this.state.lab_section_name !== "" ?
										<span style={{marginLeft:"15px"}}>
											Secciones Laboratorio: 
											<b style={{marginLeft:"5px"}}>{this.state.lab_section_name}</b>
										</span>
									:null}
								</div>
								

								<div className="col-xs-12" id="table-to-pdf">									
									<div className="table-responsive">
										<table style={{fontSize:"11px"}} className={"table table-striped"} id="table-to-xls" 
											width="100%" ref={el => this.el = el}>
										</table>
									</div>

								</div>
							</div>
						</form>
					</div>
				</div>
			</div>
		)
	}
}

export default translate('translations') (Pending);